<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="hideModal" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalNews()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ single_news.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <span v-html="single_news.content"></span>

                    <q-tabs v-if="useCommentsNews" v-model="tab" class="q-mt-xl">
                        <q-tab slot="title" name="comments" :label="$t('comments')" />

                        <q-tab-pane name="comments">
                            <div class="row gutter-sm">
                                <div class="col-12">
                                    <q-input type="textarea" rows="3" v-model="comment" :float-label="$t('comment')" :error="$v.comment.$error" @input="$v.comment.$touch" />
                                </div>
                            </div>

                            <div class="row gutter-sm justify-end q-mt-sm">
                                <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                                    <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="hideModalNews()" />
                                </div>

                                <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                                    <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveComment()" />
                                </div>
                            </div>

                            <div class="row gutter-sm q-mt-sm" v-if="comments.length > 0">
                                <div class="col-12">
                                    <q-list separator>
                                        <q-list-header inset>{{ $t('comments') }}</q-list-header>

                                        <q-item  v-for="(c, index) in comments" :key="index">
                                            <q-item-side :avatar="c.user_image ? c.user_image : getPlaceholder" />

                                            <q-item-main>
                                                <q-item-tile label>{{ c.user_name }}</q-item-tile>
                                                <q-item-tile sublabel>{{ fDate(c.created_date)}}</q-item-tile>
                                                <q-item-tile sublabel>{{ c.comment }}</q-item-tile>
                                            </q-item-main>

                                            <q-item-side right v-if="id_user === c.user_id">
                                                <q-btn flat round color="negative" icon="fal fa-trash-alt" @click="DeleteComments(c.id)"/>
                                            </q-item-side>
                                        </q-item>
                                    </q-list>
                                </div>
                            </div>
                        </q-tab-pane>
                    </q-tabs>

                </div>
            </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { required } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'news'] },

    props:['show_modal', 'id'],

    data() {
        return {
            single_news: {},
            tab: 'comments',
            comments: [],
            comment: ''
        }
    },

    computed: {
        ...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected',
            id_user: 'common/id',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
		},

        getPlaceholder() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) return client.user_avatar_placeholder
			else return ''
        },

        useCommentsNews() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) return obj.use_comments_news
            else return true
        }
    },

    methods: {
        openNews() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_news/news/${this.id}/`, this.getHeader)
            .then(response => {
                this.single_news = response.data
                this.fetchComments()
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchComments() {
            let data = {
                'page_size': 100,
                'page': 1,
            }

            this.$axios.get(`/etraining_news/news/${this.single_news.id}/get_user_comments/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.comments = response.data.results.map(e => ({ ...e }) )
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        DeleteComments(id_comment) {
            this.$q.loading.show()
            this.$axios.delete(`/etraining_news/news/${this.single_news.id}/delete_user_comment/?comment=${id_comment}`)
            .then(response => {
                this.fetchComments()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        saveComment() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    comment: this.comment
                }

                this.$axios.post(`/etraining_news/news/${this.single_news.id}/set_user_comment/`, data, this.getHeader)
                .then(response => {
                    this.comments = response.data
                    this.comment = ''
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        hideModal() {
            this.comments = []
            this.comment = ''
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        hideModalNews() {
            this.$emit('hideModalNews')
        },
    },
    validations() {
        return {
            comment: { required },
        }
    },

    watch: {
        show_modal: function(e) {
            if(this.show_modal) this.openNews()
        },
    }

}
</script>

<style>

</style>
